<template>
  <div class="app">
    <div class="navigation" :class="{ showMenu: showMenu }">
      <div class="show-hide" :class="{ showMenu: showMenu }">
        <div class="menu h3" :class="{ showMenu: showMenu }" @click="menu">
          Menu
        </div>
        <div class="close h3" :class="{ showMenu: showMenu }" @click="menu">
          Close
        </div>
      </div>
      <div class="links" :class="{ showMenu: showMenu }">
        <router-link class="link story" to="/">
          <span @click="closeMenu">
            Our Story
          </span>
        </router-link>
        <router-link
          class="link celebration"
          to="/ourcelebration"
          @click="closeMenu"
        >
          <span @click="closeMenu">
            Our Celebration
          </span>
        </router-link>
        <router-link class="link gallery" to="/gallery" @click="closeMenu">
          <span @click="closeMenu">
            Gallery
          </span>
        </router-link>
        <router-link class="link travel" to="/travel" @click="closeMenu">
          <span @click="closeMenu">
            Travel
          </span>
        </router-link>
        <router-link
          class="link accomodation"
          to="/accomodation"
          @click="closeMenu"
        >
          <span @click="closeMenu">
            Accomodation
          </span>
        </router-link>
        <router-link class="link contact" to="/contact" @click="closeMenu">
          <span @click="closeMenu">
            Contact
          </span>
        </router-link>
        <router-link class="link registry" to="/registry" @click="closeMenu">
          <span @click="closeMenu">
            Registry
          </span>
        </router-link>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      showMenu: false
    };
  },
  methods: {
    menu() {
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      this.showMenu = false;
    }
  }
};
</script>

<style lang="scss">
@import "src/scss/base.scss";

body {
  background: #ffffff;
}

.app {
  display: flex;
  flex-direction: column;
  font-family: "Cinzel", serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #333333;
}

.navigation {
  display: flex;
  flex: 1;
  justify-content: space-between;
  font-family: "Cinzel", serif;
  z-index: 3;
}

@media screen and (min-width: $screen-medium) {
  .navigation {
    padding: 0;
    z-index: 6;
  }
}

.birds-left {
  display: none;
}

@media screen and (min-width: $screen-large) {
  .birds-left {
    display: flex;
    width: 154px;
    height: 132px;
  }
}

.icon {
  position: relative;
  order: 1;
  flex: 1 0 100%;
  display: flex;
  padding: 10px 0 20px;
  justify-content: center;
}

@media screen and (min-width: $screen-large) {
  .icon {
    order: 4;
    flex: 0 0 280px;
  }
}

.christopher-and-farzna {
  position: absolute;
  bottom: 20px;
  font-family: "Parisienne", cursive;
  color: #9b9b9b;
}

@media screen and (min-width: $screen-large) {
  .christopher-and-farzna {
    font-size: 34px;
    bottom: 5px;
  }
}

.and {
  color: #855366;
}

.main-image {
  width: 100px;
  height: 141px;
}

@media screen and (min-width: $screen-large) {
  .main-image {
    display: flex;
    width: 260px;
    height: 352px;
  }
}

.date {
  display: none;
}

@media screen and (min-width: $screen-large) {
  .date {
    display: flex;
    font-family: "Roboto Slab", serif;
    position: absolute;
    left: -220px;
    bottom: 100px;
  }
}

.location {
  display: none;
}

@media screen and (min-width: $screen-large) {
  .location {
    display: flex;
    font-family: "Roboto Slab", serif;
    position: absolute;
    right: -200px;
    bottom: 90px;
    text-align: center;
    line-height: 24px;
  }
}
.birds-right {
  display: none;
}

@media screen and (min-width: $screen-large) {
  .birds-right {
    display: flex;
    width: 154px;
    height: 132px;
  }
}

.links {
  position: fixed;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  flex: 1;
  background: white;
  top: 60px;
  justify-content: space-around;
  width: 100%;
  padding: 0 0 30px 0;
  display: none;

  &.showMenu {
    display: flex;
  }
}

@media screen and (min-width: $screen-medium) {
  .links {
    display: flex;
    position: relative;
    flex-direction: row;
    padding: 0;
    background: none;
    top: 0;
  }
}

.link {
  padding: 10px 5px;
  font-size: 16px;
  line-height: 18px;
  text-decoration: none;
  color: #333333;
  text-align: center;
  order: 2;
}

@media screen and (min-width: $screen-medium) {
  .link {
    padding: 0 8px;
    font-size: 16px;
    line-height: 22px;
    text-decoration: none;
    margin: 20px 0;
  }
}

.show-hide {
  position: fixed;
  width: 100%;
  height: 60px;
  background: rgba(255, 255, 255, 0.6);

  &.showMenu {
    background: #fff;
  }
}

@media screen and (min-width: $screen-medium) {
  .show-hide {
    display: none;
  }
}

.menu {
  position: absolute;
  top: 10px;
  right: 20px;
  z-index: 2;

  &.showMenu {
    display: none;
  }
}

@media screen and (min-width: $screen-medium) {
  .menu {
    display: none;
  }
}

.close {
  position: absolute;
  top: 10px;
  right: 20px;
  z-index: 2;
  display: none;

  &.showMenu {
    display: flex;
  }
}

@media screen and (min-width: $screen-medium) {
  .close {
    display: none;

    &.showMenu {
      display: none;
    }
  }
}

.page {
  align-self: center;
  max-width: 960px;
  padding: 80px 20px 30px 20px;
}

@media screen and (min-width: $screen-medium) {
  .page {
    padding-top: 20px;
  }
}

.h1 {
  font-family: "Parisienne", cursive;
  color: #333333;
  font-size: 34px;
  line-height: 48px;
  margin-bottom: 16px;
}

.h2 {
  font-family: "Parisienne", cursive;
  font-size: 28px;
  line-height: 44px;
  font-weight: 800;
  margin-bottom: 16px;
}

.h3 {
  font-family: "Parisienne", cursive;
  font-size: 22px;
  line-height: 40px;
  font-weight: 800;
  margin-bottom: 16px;
}

.h4 {
  font-family: "Parisienne", cursive;
  font-size: 18px;
  line-height: 40px;
  font-weight: 800;
  margin-bottom: 16px;
}

.p {
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 16px;
  font-family: "Cinzel", serif;
  text-transform: none !important;
}

a {
  color: #333333;
  weight: 800;
}

@font-face {
  font-family: "melinda";
  font-style: normal;
  font-weight: normal;
  src: local("melinda"), url("./assets/melinda-script.ttf") format("truetype");
}

@font-face {
  font-family: "melinda";
  font-style: normal;
  font-weight: normal;
  src: local("melinda"), url("./assets/melinda-script.ttf") format("truetype");
}
</style>
